<button type="button" class="field" cdkOverlayOrigin #origin="cdkOverlayOrigin" [class.invalid]="invalid" [class.open]="open" [class.inline]="inline" [disabled]="disabled" [attr.aria-label]="ariaLabel" aria-haspopup="tree" [attr.aria-expanded]="open" (click)="toggle()">
  @if (path.length > 0) {
    <span class="path">
      @for (p of path; track p.id; let last = $last) {
        @if (last) {<b>{{ p.title }}</b>} @else {<span>{{ p.title }}</span><span class="sep">›</span>}
      }
    </span>
  } @else {
    <span class="ph">{{ placeholder }}</span>
  }
  @if (badge && path.length > 0) {<span class="badge">{{ badge }}</span>}
  <svg class="chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" aria-hidden="true"><path [attr.d]="chevron"></path></svg>
</button>

<ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin" [cdkConnectedOverlayOpen]="open" [cdkConnectedOverlayMinWidth]="width" [cdkConnectedOverlayOffsetY]="4" (overlayOutsideClick)="close()" (detach)="close()">
  <div class="panel" role="tree">
    <label class="psearch"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4"></path></svg><input type="search" [placeholder]="searchPlaceholder" [attr.aria-label]="searchPlaceholder" [(ngModel)]="query" (ngModelChange)="onQuery()"></label>
    <div class="rows">
      @for (r of rows; track r.kind + r.id) {
        @if (r.kind === 'node' && r.node) {
          <div class="row" role="treeitem" [class.sel]="r.selected" [class.off]="!r.allowed" [style.padding-left]="r.pad" [attr.aria-selected]="r.selected" [attr.aria-disabled]="!r.allowed" [attr.title]="r.why || null" (click)="pick(r)">
            <span class="chev2" (click)="toggleRow($event, r)">
              @if (r.open) {<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M6 9l6 6 6-6"></path></svg>}
              @if (r.closed) {<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><path d="M9 6l6 6-6 6"></path></svg>}
            </span>
            <svg class="ti" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true" [style.color]="r.color"><path [attr.d]="iconPaths[r.icon]"></path></svg>
            <span class="tn">{{ r.node.title | accessTitle }}</span>
            @if (r.why) {<span class="why">{{ r.why }}</span>}
          </div>
        } @else {
          <a class="row more" href="#" [style.padding-left]="r.pad" (click)="more($event, r)">… {{ r.moreCount }}</a>
        }
      }
      @if (loading) {<div class="state">…</div>}
      @if (!loading && rows.length === 0) {<div class="state">{{ emptyText }}</div>}
      @if (failed) {<div class="state bad">!</div>}
    </div>
  </div>
</ng-template>
